import React from 'react';
import { IconProps } from '../types/types';

const CSCO: React.FC<IconProps> = (props) => (
    <svg viewBox="0 0 18 18" xmlns="http://www.w3.org/2000/svg" role="img" {...props}><path fill="#1BA0D7" d="M0 0h18v18H0z"/><path d="M6 7v4M12 7v4M10.5 8.6v1.6M7.5 8.6v1.6M13.5 8.6v1.6M4.5 8.6v1.6M3 9.5v.5M15 9v.8M9 9v.8" stroke="#fff" strokeWidth=".75" strokeLinecap="round"/></svg>
);

export default CSCO;